import { ForwardedRef, ReactElement, forwardRef } from 'react';

import DateInput from '@/common/DateInput';
import DatetimeInput from '@/common/DatetimeInput';
import FormatInput from '@/common/FormatInput';
import { FormatInputTypes } from '@/common/FormatInput/types';
import InputBase from '@/common/Input/InputBase';
import { InputTypes } from '@/common/Input/types';
import PhoneInput from '@/common/PhoneInput';
import { PopoverInputTypes } from '@/common/PopoverInput/types';
import SwitchInput from '@/common/SwitchInput';
import TimeInput from '@/common/TimeInput';

type InputRef = InputTypes.RefType | PopoverInputTypes.RefType;
const Input = forwardRef<InputRef, { type?: InputTypes.Props['type'] } & (InputTypes.Props | FormatInputTypes.Props)>(
  ({ type, ...props }, ref): ReactElement => {
    switch (type?.toLowerCase()) {
      case 'date':
        return <DateInput {...props} value={props.value as string} ref={ref as ForwardedRef<PopoverInputTypes.RefType>} />;
      case 'time':
        return <TimeInput {...props} value={props.value as string} ref={ref as ForwardedRef<PopoverInputTypes.RefType>} />;
      case 'datetime':
      case 'datetime-local':
        return <DatetimeInput {...props} value={props.value as string} ref={ref as ForwardedRef<PopoverInputTypes.RefType>} />;
      case 'phone':
      case 'tel':
        return <PhoneInput {...props} value={props.value as string} ref={ref as ForwardedRef<InputTypes.RefType>} />;
      case 'checkbox':
      case 'radio':
      case 'switch':
        return <SwitchInput {...props} type={type} ref={ref as ForwardedRef<InputTypes.RefType>} />;
      case 'format':
        return <FormatInput {...props} value={props.value as string} ref={ref as ForwardedRef<InputTypes.RefType>} />;
      default:
        return <InputBase {...props} type={type} ref={ref as ForwardedRef<InputTypes.RefType>} />;
    }
  }
);
Input.displayName = 'Input';

export default Input;
